const Theme = {
  body_background_color: '#2A255A',

  header_border_color: '#eee',

  logo_image_url: 'pixii.png',
  logo_height: 100,

  token_url: 'pixii.png',
  number_hidden: true,

  title_font: `'Archia', serif`,
  title_uppercase: true,
  title_size: 35,
  title_lineheight: 38,

  text_font: `'Gilroy', sans-serif`,
  text_color: '#333333',
  text_size: 18,
  text_lineheight: 25,

  legend_color: '#ed1c5b',
  legend_size: 14,
  legend_style: 'italic',
  legend_weight: 500,

  button_font: `'Questrial', sans-serif`,
  button_color: '#F72585',
  button_radius: 4,
  button_text_size: 18,
  button_text_lineheight: 25,
  button_text_weight: 500,

  button_half_border_color: '#333333',
  button_half_text_color: '#333333',

  separator_color: '#F9B500',

  footer_border_color: '#eee',
}

export default Theme
